import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clients-search"
// Debounces email input and POSTs to the search endpoint, receiving a Turbo Stream
// that updates the client-search-results turbo frame.
export default class extends Controller {
  static targets = ["emailInput"]
  static values = {
    searchUrl: { type: String, default: "" },
    debounce: { type: Number, default: 400 }
  }

  connect() {
    this.timeout = null
    // Derive the search URL from the form's action or a data attribute
    if (!this.searchUrlValue) {
      this.searchUrlValue = this.element.dataset.clientsSearchSearchUrlValue ||
        document.querySelector("meta[name='clients-search-url']")?.content || ""
    }
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  search() {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.performSearch()
    }, this.debounceValue)
  }

  async performSearch() {
    const query = this.emailInputTarget.value.trim()

    if (query.length < 3) {
      const frame = document.getElementById("client-search-results")
      if (frame) frame.innerHTML = ""
      return
    }

    const url = this.resolveSearchUrl()
    if (!url) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken || ""
        },
        body: new URLSearchParams({ query })
      })

      if (response.ok) {
        const html = await response.text()
        // Let Turbo handle the stream response
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error("Client search failed:", error)
    }
  }

  resolveSearchUrl() {
    if (this.searchUrlValue) return this.searchUrlValue

    // Fall back to the data attribute on the element
    return this.element.dataset.searchUrl || null
  }
}
